import "@/App.css";
import { useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import { AuthCallback } from "@/auth/AuthCallback";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import Landing from "@/pages/Landing";
import Why from "@/pages/Why";
import JournalIndex from "@/pages/JournalIndex";
import JournalPost from "@/pages/JournalPost";
import Chatbot from "@/pages/Chatbot";
import SignIn from "@/pages/SignIn";
import Profile from "@/pages/Profile";
import Assessment from "@/pages/Assessment";
import ReportReady from "@/pages/ReportReady";
import Unlock from "@/pages/Unlock";
import Account from "@/pages/Account";
import AdminOrders from "@/pages/AdminOrders";
import SupplementCheck from "@/pages/SupplementCheck";
import QuestionsFallback from "@/pages/QuestionsFallback";
import DoctorRequest from "@/pages/DoctorRequest";
import { FloatingChatLauncher } from "@/components/chat/FloatingChatLauncher";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/why" element={<Why />} />
      <Route path="/journal" element={<JournalIndex />} />
      <Route path="/journal/:slug" element={<JournalPost />} />
      <Route path="/blog" element={<JournalIndex />} />
      <Route path="/blog/:slug" element={<JournalPost />} />
      <Route path="/chat" element={<Chatbot />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/profile" element={<ProtectedRoute requireProfile={false}><Profile /></ProtectedRoute>} />
      <Route path="/check" element={<ProtectedRoute><Assessment tier="free" /></ProtectedRoute>} />
      <Route path="/report-ready" element={<ProtectedRoute><ReportReady /></ProtectedRoute>} />
      <Route path="/screen" element={<ProtectedRoute><Assessment tier="paid" /></ProtectedRoute>} />
      <Route path="/unlock" element={<ProtectedRoute><Unlock /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminOrders /></ProtectedRoute>} />
      <Route path="/admin/approve" element={<ProtectedRoute requireAdmin><AdminOrders /></ProtectedRoute>} />
      <Route path="/supplement-check" element={<SupplementCheck />} />
      <Route path="/doctor-request" element={<DoctorRequest />} />
      <Route path="/questions/*" element={<QuestionsFallback />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppRoutes />
          <FloatingChatLauncher />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFBF6",
            color: "#1C1917",
            border: "1px solid #F1D9C6",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
